export default __webpack_public_path__ + "static/media/astrox100zz.1eaf6636.webp";